import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { InputField } from "@src/shared/ui/InputField";
import { Button, IconButton, InputAdornment } from "@mui/material";
import { backButtonStyles, saveBtnStyles } from "../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { changePasswordSchema } from "./constants";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import { useChangePassword } from "@src/entities/user";

import styles from "./ChangePassword.module.scss";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

interface ChangePasswordParams {
  current_password: string;
  new_password: string;
  double_password: string;
}

export const ChangePassword = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showDoublePassword, setShowDoublePassword] = useState(false);

  const { mutate: changePassword } = useChangePassword();
  const updateAccessToken = useAuthStore((state) => state.updateAccessToken);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<ChangePasswordParams>({
    defaultValues: {
      new_password: "",
      current_password: "",
      double_password: "",
    },
    resolver: yupResolver(changePasswordSchema) as any,
    mode: "onChange",
  });

  const onSubmit = (data: ChangePasswordParams) => {
    const { double_password, ...params } = data;

    changePassword(params, {
      onSuccess: (data) => {
        updateAccessToken(data?.data?.tokens?.access);
        navigate("/personal-cab");
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <InputField
        control={control}
        name="current_password"
        label="Старый пароль"
        className={styles.inputField}
        classNameForWrapper={styles.inputFieldWrapper}
        type={showCurrentPassword ? "text" : "password"}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{ color: "#a4bbc7bb", mr: 1 }}
                  onClick={() => setShowCurrentPassword((show) => !show)}
                  edge="end"
                >
                  {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <InputField
        control={control}
        name="new_password"
        label="Новый пароль"
        classNameForWrapper={styles.inputFieldWrapper}
        className={styles.inputField}
        type={showNewPassword ? "text" : "password"}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{ color: "#a4bbc7bb", mr: 1 }}
                  onClick={() => setShowNewPassword((show) => !show)}
                  edge="end"
                >
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <InputField
        control={control}
        name="double_password"
        label="Повторить пароль"
        classNameForWrapper={styles.inputFieldWrapper}
        className={styles.inputField}
        type={showDoublePassword ? "text" : "password"}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{ color: "#a4bbc7bb", mr: 1 }}
                  onClick={() => setShowDoublePassword((show) => !show)}
                  edge="end"
                >
                  {showDoublePassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        disabled={!isValid}
        sx={saveBtnStyles}
      >
        Сохранить
      </Button>
      <Button
        variant="text"
        onClick={() => navigate("/personal-cab")}
        sx={backButtonStyles}
        type="button"
        startIcon={<ArrowBack />}
      >
        Вернуться
      </Button>
    </form>
  );
};
